import { useContext } from "react";
import { AuthContext } from "../context/AuthProvider";
import {  Navigate, useLocation } from "react-router-dom";
import Loder from "../components/Loder";

const PrivateRoute = ({ children }) => {
  const { user, authLoading } = useContext(AuthContext);
  const location = useLocation();

  if (authLoading) {
    return <Loder />;
  }
  if (user) {
    return children;
  } else {
    return (
      <Navigate
        state={{
          pathName: location.pathname,
          product: location?.state?.product,
        }}
        to="/login"
        replace
      />
    );
  }
};

export default PrivateRoute;
